export const JSON_META_SCHEMA_RU = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  $id: 'http://json-schema.org/draft-07/schema#',
  title: 'Мета-схема ядра',
  definitions: {
    schemaArray: {
      type: 'array',
      minItems: 1,
      items: {
        $ref: '#',
      },
      title: 'Массив схем',
      description: 'Массив, содержащий одну или более валидных JSON схем',
      errorMessage: {
        type: 'Должно быть массивом',
        minItems: 'Должен содержать хотя бы одну схему',
      },
    },
    nonNegativeInteger: {
      type: 'integer',
      minimum: 0,
      title: 'Неотрицательное целое число',
      description: 'Целочисленное значение, которое больше или равно нулю',
      errorMessage: {
        type: 'Должно быть целым числом',
        minimum: 'Должно быть неотрицательным числом (>= 0)',
      },
    },
    nonNegativeIntegerDefault0: {
      allOf: [
        {
          $ref: '#/definitions/nonNegativeInteger',
        },
        {
          default: 0,
        },
      ],
      title: 'Неотрицательное целое число со значением по умолчанию 0',
      description: 'Неотрицательное целое число, которое по умолчанию равно 0, если не указано',
    },
    simpleTypes: {
      enum: ['array', 'boolean', 'integer', 'null', 'number', 'object', 'string'],
      title: 'Простые типы',
      description: 'Основные примитивные типы, доступные в JSON Schema',
      errorMessage: {
        enum: 'Должно быть одним из допустимых типов: array, boolean, integer, null, number, object, string',
      },
    },
    stringArray: {
      type: 'array',
      items: {
        type: 'string',
      },
      uniqueItems: true,
      default: [],
      title: 'Массив строк',
      description: 'Массив уникальных строковых значений',
      errorMessage: {
        type: 'Должно быть массивом',
        items: 'Все элементы должны быть строками',
        uniqueItems: 'Все элементы должны быть уникальными',
      },
    },
  },
  type: ['object', 'boolean'],
  properties: {
    $id: {
      type: 'string',
      format: 'uri-reference',
      title: 'Идентификатор схемы',
      description: 'Уникальный идентификатор схемы, обычно URI',
      errorMessage: {
        type: 'Должно быть строкой',
        format: 'Должно быть валидной URI ссылкой',
      },
    },
    $schema: {
      type: 'string',
      format: 'uri',
      title: 'Диалект схемы',
      description: 'URI версии спецификации JSON Schema, которой следует данная схема',
      errorMessage: {
        type: 'Должно быть строкой',
        format: 'Должно быть валидным URI',
      },
    },
    $ref: {
      type: 'string',
      format: 'uri-reference',
      title: 'Ссылка на схему',
      description: 'URI ссылка на другую схему или фрагмент схемы',
      errorMessage: {
        type: 'Должно быть строкой',
        format: 'Должно быть валидной URI ссылкой',
      },
    },
    $comment: {
      type: 'string',
      title: 'Комментарий',
      description: 'Комментарий для авторов схемы, не используется при валидации',
      errorMessage: {
        type: 'Должно быть строкой',
      },
    },
    title: {
      type: 'string',
      title: 'Заголовок',
      description: 'Краткое описательное название схемы',
      errorMessage: {
        type: 'Должно быть строкой',
      },
    },
    description: {
      type: 'string',
      title: 'Описание',
      description: 'Подробное объяснение назначения и использования схемы',
      errorMessage: {
        type: 'Должно быть строкой',
      },
    },
    default: true,
    readOnly: {
      type: 'boolean',
      default: false,
      title: 'Только для чтения',
      description: 'Указывает, что значение не должно изменяться (используется в контексте гиперсхем)',
      errorMessage: {
        type: 'Должно быть булевым значением (true/false)',
      },
    },
    writeOnly: {
      type: 'boolean',
      default: false,
      title: 'Только для записи',
      description: 'Указывает, что значение может быть установлено, но не должно быть получено (например, пароли)',
      errorMessage: {
        type: 'Должно быть булевым значением (true/false)',
      },
    },
    examples: {
      type: 'array',
      items: true,
      title: 'Примеры',
      description: 'Массив примеров значений, которые валидны для этой схемы',
      errorMessage: {
        type: 'Должно быть массивом',
      },
    },
    multipleOf: {
      type: 'number',
      exclusiveMinimum: 0,
      title: 'Кратное',
      description: 'Проверяет, что числовое значение является кратным этому числу',
      errorMessage: {
        type: 'Должно быть числом',
        exclusiveMinimum: 'Должно быть больше 0',
      },
    },
    maximum: {
      type: 'number',
      title: 'Максимум',
      description: 'Максимальное значение для числового экземпляра (включительно)',
      errorMessage: {
        type: 'Должно быть числом',
      },
    },
    exclusiveMaximum: {
      type: 'number',
      title: 'Исключающий максимум',
      description: 'Максимальное значение для числового экземпляра (исключительно)',
      errorMessage: {
        type: 'Должно быть числом',
      },
    },
    minimum: {
      type: 'number',
      title: 'Минимум',
      description: 'Минимальное значение для числового экземпляра (включительно)',
      errorMessage: {
        type: 'Должно быть числом',
      },
    },
    exclusiveMinimum: {
      type: 'number',
      title: 'Исключающий минимум',
      description: 'Минимальное значение для числового экземпляра (исключительно)',
      errorMessage: {
        type: 'Должно быть числом',
      },
    },
    maxLength: {
      $ref: '#/definitions/nonNegativeInteger',
      title: 'Максимальная длина',
      description: 'Максимальная длина строкового экземпляра',
    },
    minLength: {
      $ref: '#/definitions/nonNegativeIntegerDefault0',
      title: 'Минимальная длина',
      description: 'Минимальная длина строкового экземпляра',
    },
    pattern: {
      type: 'string',
      format: 'regex',
      title: 'Шаблон',
      description: 'Регулярное выражение, которому должен соответствовать строковый экземпляр',
      errorMessage: {
        type: 'Должно быть строкой',
        format: 'Должно быть валидным регулярным выражением',
      },
    },
    additionalItems: {
      $ref: '#',
      title: 'Дополнительные элементы',
      description: 'Схема для валидации элементов массива, не охваченных ключевым словом items',
    },
    items: {
      anyOf: [
        {
          $ref: '#',
        },
        {
          $ref: '#/definitions/schemaArray',
        },
      ],
      default: true,
      title: 'Элементы',
      description: 'Схема или схемы для валидации элементов массива',
    },
    maxItems: {
      $ref: '#/definitions/nonNegativeInteger',
      title: 'Максимальное количество элементов',
      description: 'Максимальное количество элементов, допустимое в массиве',
    },
    minItems: {
      $ref: '#/definitions/nonNegativeIntegerDefault0',
      title: 'Минимальное количество элементов',
      description: 'Минимальное количество элементов, требуемое в массиве',
    },
    uniqueItems: {
      type: 'boolean',
      default: false,
      title: 'Уникальные элементы',
      description: 'Если true, все элементы в массиве должны быть уникальными',
      errorMessage: {
        type: 'Должно быть булевым значением (true/false)',
      },
    },
    contains: {
      $ref: '#',
      title: 'Содержит',
      description: 'Проверяет, что по крайней мере один элемент массива соответствует этой схеме',
    },
    maxProperties: {
      $ref: '#/definitions/nonNegativeInteger',
      title: 'Максимальное количество свойств',
      description: 'Максимальное количество свойств, допустимое в объекте',
    },
    minProperties: {
      $ref: '#/definitions/nonNegativeIntegerDefault0',
      title: 'Минимальное количество свойств',
      description: 'Минимальное количество свойств, требуемое в объекте',
    },
    required: {
      $ref: '#/definitions/stringArray',
      title: 'Обязательные',
      description: 'Массив имен свойств, которые должны присутствовать в объекте',
    },
    additionalProperties: {
      $ref: '#',
      title: 'Дополнительные свойства',
      description: 'Схема для валидации свойств, не определенных явно',
    },
    definitions: {
      type: 'object',
      additionalProperties: {
        $ref: '#',
      },
      default: {},
      title: 'Определения',
      description: 'Контейнер для переиспользуемых определений схем, на которые ссылаются в другом месте',
      errorMessage: {
        type: 'Должно быть объектом',
      },
    },
    properties: {
      type: 'object',
      additionalProperties: {
        $ref: '#',
      },
      default: {},
      title: 'Свойства',
      description: 'Определения схем для свойств объекта',
      errorMessage: {
        type: 'Должно быть объектом',
      },
    },
    patternProperties: {
      type: 'object',
      additionalProperties: {
        $ref: '#',
      },
      propertyNames: {
        format: 'regex',
      },
      default: {},
      title: 'Свойства по шаблону',
      description: 'Определения схем для свойств, соответствующих регулярным выражениям',
      errorMessage: {
        type: 'Должно быть объектом',
        propertyNames: 'Имена свойств должны быть валидными регулярными выражениями',
      },
    },
    dependencies: {
      type: 'object',
      additionalProperties: {
        anyOf: [
          {
            $ref: '#',
          },
          {
            $ref: '#/definitions/stringArray',
          },
        ],
      },
      title: 'Зависимости',
      description: 'Определяет зависимости свойств или схем между свойствами объекта',
      errorMessage: {
        type: 'Должно быть объектом',
      },
    },
    propertyNames: {
      $ref: '#',
      title: 'Имена свойств',
      description: 'Схема, которой должны соответствовать все имена свойств',
    },
    const: true,
    enum: {
      type: 'array',
      items: true,
      minItems: 1,
      uniqueItems: true,
      title: 'Перечисление',
      description: 'Массив допустимых значений; экземпляр должен быть равен одному из этих значений',
      errorMessage: {
        type: 'Должно быть массивом',
        minItems: 'Должен содержать хотя бы одно значение',
        uniqueItems: 'Все значения должны быть уникальными',
      },
    },
    type: {
      anyOf: [
        {
          $ref: '#/definitions/simpleTypes',
        },
        {
          type: 'array',
          items: {
            $ref: '#/definitions/simpleTypes',
          },
          minItems: 1,
          uniqueItems: true,
        },
      ],
      title: 'Тип',
      description: 'JSON тип(ы), которым должен соответствовать экземпляр',
      errorMessage: {
        anyOf: 'Должно быть либо простым типом, либо массивом простых типов',
      },
    },
    format: {
      type: 'string',
      title: 'Формат',
      description: "Семантическая валидация для строковых значений (например, 'email', 'date-time', 'uri')",
      errorMessage: {
        type: 'Должно быть строкой',
      },
    },
    contentMediaType: {
      type: 'string',
      title: 'MIME-тип содержимого',
      description: "MIME-тип строкового содержимого (например, 'application/json')",
      errorMessage: {
        type: 'Должно быть строкой',
      },
    },
    contentEncoding: {
      type: 'string',
      title: 'Кодировка содержимого',
      description: "Кодировка, используемая для строкового содержимого (например, 'base64')",
      errorMessage: {
        type: 'Должно быть строкой',
      },
    },
    if: {
      $ref: '#',
      title: 'Если',
      description: "Условная схема; используется с 'then' и 'else' для условной валидации",
    },
    then: {
      $ref: '#',
      title: 'Тогда',
      description: "Схема для применения, если схема 'if' успешно валидируется",
    },
    else: {
      $ref: '#',
      title: 'Иначе',
      description: "Схема для применения, если схема 'if' не прошла валидацию",
    },
    allOf: {
      $ref: '#/definitions/schemaArray',
      title: 'Все из',
      description: 'Экземпляр должен соответствовать всем предоставленным схемам',
    },
    anyOf: {
      $ref: '#/definitions/schemaArray',
      title: 'Любой из',
      description: 'Экземпляр должен соответствовать по крайней мере одной из предоставленных схем',
    },
    oneOf: {
      $ref: '#/definitions/schemaArray',
      title: 'Один из',
      description: 'Экземпляр должен соответствовать ровно одной из предоставленных схем',
    },
    not: {
      $ref: '#',
      title: 'Не',
      description: 'Экземпляр не должен соответствовать этой схеме',
    },
  },
  default: true,
};
